interface MeasurementMapper<T> {
  from: {
    METRIC: {
      to: {
        METRIC?: {
          [unit: string]: T;
        };
        IMPERIAL: {
          [unit: string]: T;
        };
      };
    };
    IMPERIAL: {
      to: {
        METRIC: {
          [unit: string]: T;
        };
        IMPERIAL?: {
          [unit: string]: T;
        };
      };
    };
  };
}

export const measurementUnits = {
  METRIC: {
    'kW/100CFM': 'kW/(m^3/min)',
    CFM: 'm3/min',
    PSI: 'Bar',
    psi: 'bar',
    '°F': '°C',
    '°f': '°c',
    Fahrenheit: 'Celsius',
    fahrenheit: 'celsius',
    Gallon: 'Liter',
    gallon: 'liter',
    inch: 'mm',
    ratedHP: 'kW', // Rated Power kW -> HP unit conversion
    kWh: 'kWh',
    RPM: 'RPM',
    hour: 'hour',
    mils: 'microns',
    GPM: 'm3/hour',
    Hz: 'Hz',
    'kWh/MG': 'kWh/MG',
  },
  IMPERIAL: {
    'kW/(m^3/min)': 'kW/100CFM',
    'kW/(m3/min)': 'kW/100CFM',
    'm^3/min': 'CFM',
    'm3/min': 'CFM',
    'm^3': 'ft^3',
    Bar: 'PSI',
    bar: 'psi',
    '°C': '°F',
    '°c': '°f',
    Celsius: 'Fahrenheit',
    celsius: 'fahrenheit',
    Liter: 'Gallon',
    liter: 'gallon',
    mm: 'inch',
    ratedHP: 'HP', // Rated Power kW -> HP unit conversion
    kWh: 'kWh',
    RPM: 'RPM',
    hour: 'hour',
    microns: 'mils',
    'm3/hour': 'GPM',
    Hz: 'Hz',
    'kWh/MG': 'kWh/MG',
  },
};

export const decimalPrecisions: MeasurementMapper<number> = {
  from: {
    METRIC: {
      to: {
        METRIC: {
          bar: 2,
          'm^3/min': 1,
          'm3/min': 1,
          celsius: 1,
          '°c': 1,
          'kw/(m^3/min)': 2,
          'kw/(m3/min)': 2,
          kw: 0,
          hp: 0,
          kWh: 1,
          liter: 0,
          hour: 0,
          minute: 0,
          a: 0,
          rpm: 0,
          microns: 2,
          'm3/hour': 1,
          Hz: 1,
        },
        IMPERIAL: {
          'kw/(m^3/min)': 1,
          'kw/(m3/min)': 1,
          'm^3/min': 0,
          'm3/min': 0,
          bar: 1,
          kw: 0,
          hp: 0,
          kWh: 1,
          celsius: 1,
          '°c': 1,
          liter: 0,
          mm: 0,
          hour: 0,
          minute: 0,
          a: 0,
          rpm: 0,
          microns: 3,
          'm3/hour': 1,
          Hz: 1,
        },
      },
    },
    IMPERIAL: {
      to: {
        METRIC: {
          kWh: 1,
          Hz: 1,
          hp: 0,
        },
        IMPERIAL: {
          psi: 1,
          cfm: 0,
          fahrenheit: 1,
          '°f': 1,
          'kw/100cfm': 1,
          kWh: 1,
          gallon: 0,
          mils: 1,
          GPM: 1,
          Hz: 1,
          hp: 0,
        },
      },
    },
  },
};

export const conversionRatios: MeasurementMapper<(v: number) => number> = {
  from: {
    METRIC: {
      to: {
        IMPERIAL: {
          'kw/(m^3/min)': v => v * 2.83168,
          'kw/(m3/min)': v => v * 2.83168,
          'm^3/min': v => v * 35.3147,
          'm3/min': v => v * 35.3147,
          'm^3/hour': v => v * 4.4029,
          bar: v => v * 14.5038,
          kw: v => v,
          kWh: v => v,
          celsius: v => v * (9 / 5) + 32,
          '°c': v => v * (9 / 5) + 32,
          liter: v => v * 0.264172,
          mm: v => v / 25.4,
          hour: v => v,
          minute: v => v,
          a: v => v,
          rpm: v => v,
          microns: v => v / 25.4,
          'm3/hour': v => v * 4.40287,
          Hz: v => v,
          hp: v => v,
        },
      },
    },
    IMPERIAL: {
      to: {
        METRIC: {
          psi: v => v / 14.5038,
          cfm: v => v / 35.3147,
          fahrenheit: v => (v - 32) * (5 / 9),
          '°f': v => (v - 32) * (5 / 9),
          'kw/100cfm': v => v / 2.83168,
          kWh: v => v,
          gallon: v => v / 0.264172,
          inch: v => v * 25.4,
          mils: v => v * 25.4,
          GPM: v => v / 0.227124,
          Hz: v => v,
          hp: v => v * 0.7457, // Hp to kW
        },
      },
    },
  },
};

export const unitTypes = {
  LITER: 'liter',
  GALLON: 'gallon',
  BAR: 'bar',
  PSI: 'psi',
  HP: 'hp',
  KW: 'kw',
};
